import React from 'react';

export default {
  returnButtonLabel: 'Volver',
  continueButtonLabel: 'Continuar',
  redemptDomain: 'Rescatar dominio',
  continueButton: 'Continuar',
  banner: {},
  inputDomainStep: {
    title: '¿Cuál será la dirección de su sitio web?',
    description: 'Digite el nombre de dominio que desee y elija entre las extensiones disponibles para rescatar su dominio gratuito.',
    tooltipLabel: 'Después de un año, la renovación del dominio tendrá un costo.',
    searchTld: 'Buscar extensión',
    freeTag: 'Gratis',
    otherOptionsLabel: 'Aquí algunas alternativas:',
    myDataButtonLabel: 'Mis datos',
    featuredLabel: 'Destacado',
    radixUnavailable: (domain, radixDomain) => (
      <>
        {'El dominio '}
        <strong>{`"${radixDomain}"`}</strong>
        {' ya está registrado. Al hacer clic en "Continuar", solo registrarás el '}
        <strong>{`"${domain}"`}</strong>
      </>
    ),
    invalidDocumentDescription: (
      <>
        <strong>
          {'Para continuar, en Perfil, vaya a la página Mis datos y actualice sus informaciones. '}
        </strong>
        Luego, vuelva a este flujo para completar la compra.
      </>
    ),
    inputErrors: {
      invalidDomain: '¡Dominio inválido!',
      startOrEndWithHyphen: 'El dominio no puede comenzar o terminar con un guion',
      twoHyphensInARow: 'El dominio no puede tener dos guiones seguidos',
      lessThanThreeCharacters: 'Utilice 3 caracteres o más para su dominio',
      hasSpecialChars: 'El dominio no puede tener caracteres especiales, excepto el guion',
      domainIsUnavailable: 'Parece que este dominio ya tiene dueño. ¡Pruebe con otro nombre o elija una de las opciones disponibles!',
      unavailableWithoutChoose: 'Dominio no disponible. ¡Pruebe con otro nombre o elija una de las opciones disponibles!',
      documentIsInvalid: 'Su documento no cumple con los requisitos para la compra o indica que es menor de 18 años.',
    },
  },
  planTurboFreeDomainStep: {
    title: '¿Quiere activar otro dominio gratis?',
    description: 'Con el Plan Turbo, tiene derecho a un segundo dominio gratis durante un año.',
    activeRadix: {
      title: 'Activar dominio gratuito',
      about: 'Su dominio será registrado sin costo (gratis). Después de un año, deberá renovarlo pagando una tarifa.',
    },
    refuseRadix: {
      title: 'No activar el dominio gratuito',
      about: 'Si elige no activarlo, perderá el derecho a este dominio gratuito.',
    },
  },
  successStep: {
    content: ({ domains }) => {
      const singleDomain = {
        description: `¡Su dominio "${domains[0]}" fue rescatado exitosamente!`,
        infoList: ['Ahora está disponible para usar en su cuenta'],
        renewalNotice: 'Después de un año, la renovación del dominio tendrá un costo.',
      };

      const multipleDomains = {
        description: `¡Los dominios "${domains[0]}" y "${domains[1]}" fueron rescatados exitosamente!`,
        infoList: ['Ahora están disponibles para usar en su cuenta'],
        renewalNotice: 'Después de un año, la renovación de los dominios tendrán un costo.',
      };

      return ({
        title: '¡Excelente elección!',
        ...domains.length === 1 ? singleDomain : multipleDomains,
      });
    },
  },
  errors: {
    unexpectedErrorTitle: 'Ocurrió un error inesperado',
    unexpectedErrorInfo: 'Inténtalo más tarde',
  },
};
